// Author Liang Gangqiang
// Date 2022-08-18 16:13:57

class EmArchScrapProcessAsp {
constructor({
        id = null,
        status = '',
        workOrderCode = '',
        scrapType = '',
        currentResult = '',
        scrapItems = '',
        remark = '',
        currentAssignee = ''}
= {}) {
    this.id = id;
    this.status = status;
    this.workOrderCode = workOrderCode;
    this.scrapType = scrapType;
    this.currentResult = currentResult;
    this.scrapItems = scrapItems;
    this.remark = remark;
    this.currentAssignee = currentAssignee;
}
}

function newEntity() {
return new EmArchScrapProcessAsp();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.archive.emArchScrapProcessAsp.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'statusName',
        label: 'label.em.archive.emArchScrapProcessAsp.grid.statusName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'currentAssigneeName',
        label: 'label.em.archive.emArchScrapProcessAsp.grid.currentAssigneeName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'workOrderCode',
        label: 'label.em.archive.emArchScrapProcessAsp.grid.workOrderCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'scrapType',
        label: 'label.em.archive.emArchScrapProcessAsp.grid.scrapType',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: '设备' },
                            { value: '2', text: '工装' },
                            { value: '3', text: '工具/刀具' }
            ]
        }
        },
        {
        key: 'createdTime',
        label: 'label.em.archive.emArchScrapProcessAsp.grid.createdTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'createdByName',
        label: 'label.em.archive.emArchScrapProcessAsp.grid.createdByName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'currentResult',
        label: 'label.em.archive.emArchScrapProcessAsp.grid.currentResult',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'scrapItems',
        label: 'label.em.archive.emArchScrapProcessAsp.grid.scrapItems',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchScrapProcessAsp.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        },
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    statusFilter : '',
    currentAssigneeNameFilter : '',
    workOrderCodeFilter : '',
    scrapTypeFilter : '',
    createdByNameFilter : '',
    createdTimeRteFilter : '',
    createdTimeLteFilter : '',
    currentResultFilter : '',
    scrapItemsFilter : '',
    workflowQueryTypeFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'statusFilter',
        label: 'label.em.archive.emArchScrapProcessAsp.filter.status',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emActProcessStatus'
            ,showLabelSelectOne: true
                    ,selectFilter:{processBusinessEntityFilter:'EmArchScrapProcessAsp',statusFilter:1}
        }
        },
        {
        key: 'currentAssigneeNameFilter',
        label: 'label.em.archive.emArchScrapProcessAsp.filter.currentAssigneeName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'workOrderCodeFilter',
        label: 'label.em.archive.emArchScrapProcessAsp.filter.workOrderCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'scrapTypeFilter',
        label: 'label.em.archive.emArchScrapProcessAsp.filter.scrapType',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '设备' },
                { value: '2', text: '工装' },
                { value: '3', text: '工具/刀具' }
            ]
        }
        },
        {
        key: 'createdByNameFilter',
        label: 'label.em.archive.emArchScrapProcessAsp.filter.createdByName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'createdTimeRteFilter',
        label: 'label.em.archive.emArchScrapProcessAsp.filter.createdTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'createdTimeLteFilter',
        label: 'label.em.archive.emArchScrapProcessAsp.filter.createdTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'currentResultFilter',
        label: 'label.em.archive.emArchScrapProcessAsp.filter.currentResult',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'scrapItemsFilter',
        label: 'label.em.archive.emArchScrapProcessAsp.filter.scrapItems',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'scrapType',
        label: 'label.em.archive.emArchScrapProcessAsp.entity.scrapType',
        sortable: true,
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '设备' },
                { value: '2', text: '工装' },
                { value: '3', text: '工具/刀具' }
            ]
        }
        },
        {
        key: 'currentResult',
        label: 'label.em.archive.emArchScrapProcessAsp.entity.currentResult',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'scrapItems',
        label: 'label.em.archive.emArchScrapProcessAsp.entity.scrapItems',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchScrapProcessAsp.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        },
]

export {EmArchScrapProcessAsp, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
